/**
 * Datums- und Zeit-Hilfsfunktionen
 */

/**
 * Formatiert einen Timestamp als lokalisierte Datum/Zeit-Zeichenkette
 */
export function commentTimeString(time: number): string {
	return new Date(time).toLocaleString();
}

/**
 * Formatiert ein ISO-Datum als YYYY-MM-DD String für HTML date inputs
 */
export function dateString(dateStr: string | undefined): string {
	if (!dateStr) return '';
	const date = new Date(dateStr);
	const str = date?.toISOString()?.split('T')[0];
	return str;
}

/**
 * Formatiert ein Datum als UTC-String
 */
export function dateUTCString(dateStr: string | number): string {
	return new Date(dateStr).toUTCString();
}
